import { Component } from '@angular/core';

@Component({
    selector: 'item-card-skeleton',
    templateUrl: 'item-card-skeleton.component.html',
    styleUrl: 'item-card-skeleton.component.scss',
    standalone: true,
})
export class ItemCardSkeletonComponent {}
